/* BIA filter + sort.
   Filtering happens through Shopify's real URLs. AJAX is a progressive
   enhancement: if a fetch fails or is unsupported, the form submits normally
   and the links navigate, so filtering always works.
   The old grid is never removed until replacement HTML has arrived. */
(function () {
  var BOUND = 'biaFiltersBound';
  var controller = null;
  var cache = {};

  function root() { return document.querySelector('[data-bia-filters]'); }
  function grid() { return document.querySelector('.bgrid'); }

  function lock(on) { document.body.style.overflow = on ? 'hidden' : ''; }

  var lastTrigger = null;
  function openSheet(which, trigger) {
    var d = document.getElementById(which === 'sort' ? 'bia-sort-sheet' : 'bia-filter-drawer');
    if (!d) return;
    lastTrigger = trigger || null;
    if (d.showModal && !d.open) d.showModal();
    lock(true);
    var f = d.querySelector('button,input,a[href]');
    if (f) f.focus();
  }
  function closeSheets() {
    ['bia-filter-drawer', 'bia-sort-sheet'].forEach(function (id) {
      var d = document.getElementById(id);
      if (d && d.open && d.close) d.close();
    });
    lock(false);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  function announce(n) {
    var live = document.getElementById('bia-filter-live');
    if (!live) {
      live = document.createElement('p');
      live.id = 'bia-filter-live';
      live.className = 'vh';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = n + (n === 1 ? ' piece' : ' pieces') + ' found';
  }

  /* fetch a filtered collection URL and swap in the new grid + controls */
  function load(url, push) {
    var g = grid();
    if (!g || !window.fetch) { window.location.href = url; return; }

    if (cache[url]) { apply(cache[url], url, push); return; }
    if (controller) controller.abort();
    controller = new AbortController();

    g.classList.add('bfl__busy');
    fetch(url, { signal: controller.signal })
      .then(function (r) { if (!r.ok) throw new Error('filter'); return r.text(); })
      .then(function (html) { cache[url] = html; apply(html, url, push); })
      .catch(function (e) {
        if (e.name === 'AbortError') return;
        g.classList.remove('bfl__busy');
        window.location.href = url;      /* honest fallback */
      });
  }

  function apply(html, url, push) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newGrid = doc.querySelector('.bgrid');
    var newCtl = doc.querySelector('[data-bia-filters]');
    var oldGrid = grid();
    var oldCtl = root();
    var wrap = oldGrid ? oldGrid.parentNode : null;

    if (newGrid && oldGrid) oldGrid.replaceWith(newGrid);
    else if (!newGrid && oldGrid && wrap) {
      /* zero results: show a designed empty state, never a blank grid */
      var base = url.split('?')[0];
      oldGrid.outerHTML = '<div class="bfl__empty"><h3>No pieces meet every selection.</h3>' +
        '<p>Remove one filter to open the edit again.</p>' +
        '<a class="bfd__apply" style="display:inline-flex;align-items:center;justify-content:center;padding:0 1.4rem;text-decoration:none" href="' + base + '">Clear all filters</a></div>';
    }
    if (newCtl && oldCtl) oldCtl.replaceWith(newCtl);

    var n = newCtl ? parseInt(newCtl.getAttribute('data-count'), 10) : 0;
    if (!isNaN(n)) announce(n);

    if (push !== false) history.pushState({ bia: true }, '', url);
    closeSheets();
    var g2 = grid();
    if (g2) g2.classList.remove('bfl__busy');
  }

  /* ---------- delegated events (survive grid replacement) ---------- */
  function bind() {
    if (document[BOUND]) return;
    document[BOUND] = true;

    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-bfl-open]');
      if (open) { e.preventDefault(); openSheet(open.getAttribute('data-bfl-open'), open); return; }
      if (e.target.closest('[data-bfl-close]')) { e.preventDefault(); closeSheets(); return; }
      var link = e.target.closest('[data-bfl-link]');
      if (link && link.href) { e.preventDefault(); load(link.href, true); return; }
    });

    /* checkbox / price form */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-bfl-form]');
      if (!form || !window.fetch) return;
      e.preventDefault();
      var qs = new URLSearchParams(new FormData(form));
      /* strip empty price fields so Shopify does not receive blank params */
      Array.from(qs.keys()).forEach(function (k) { if (!qs.get(k)) qs.delete(k); });
      load(form.action + '?' + qs.toString(), true);
    });

    /* sort radio applies immediately, preserving active filters */
    document.addEventListener('change', function (e) {
      var s = e.target.closest('[data-bfl-sort]');
      if (!s) return;
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      load(u.toString(), true);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var d = document.querySelector('.bfd[open]');
      if (d) { e.preventDefault(); closeSheets(); }
    });

    window.addEventListener('popstate', function () { load(window.location.href, false); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
